<template>
  <main>
    <!-- <Breadcrumb></Breadcrumb> -->
    <transition class="content">
      <router-view :key="$route.fullPath" />
    </transition>
  </main>
</template>

<script>

// import Breadcrumb from "@/components/common/Breadcrumb.vue";

export default {
  name: "ContentView",
  components: {
    // Breadcrumb
  },

};
</script>
